import { createFileRoute } from '@tanstack/react-router'

import {
  BulkEditTransactionsDialog,
  CheckAccountsSummary,
  CheckReviewWorkspace,
  ChecksReviewBanner,
  ChecksStats,
  DeleteTransactionsDialog,
  EditTransactionDialog,
  TransactionsTable,
  useCheckTransactions,
  useFetchChecks,
  useFetchProject,
} from '@/modules/projects'
import { checkFilterSchema } from '@/schemas/transactionFilterSchema'
import { FiltersProvider } from '@/stores'

export const Route = createFileRoute('/_authenticated/projects/$slug/checks')({
  component: ProjectChecks,
  validateSearch: (search: Record<string, unknown>) => {
    const result: Record<string, string | number | undefined> = {
      page: search.page ? Number(search.page) : undefined,
      perPage: search.perPage ? Number(search.perPage) : undefined,
    }
    return result
  },
})

function ProjectChecks() {
  const { slug } = Route.useParams()
  useFetchProject(slug)
  useFetchChecks(slug)
  const checks = useCheckTransactions()

  return (
    <FiltersProvider contextId={`project-${slug}-checks`} withSearchParams>
      <div className="flex-1 min-h-0 flex flex-col gap-3">
        <EditTransactionDialog />
        <DeleteTransactionsDialog />
        <BulkEditTransactionsDialog />
        <CheckReviewWorkspace />
        <ChecksReviewBanner />
        <CheckAccountsSummary checks={checks} />
        <ChecksStats checks={checks} />
        <TransactionsTable
          transactions={checks}
          filterSchema={checkFilterSchema}
          paginationKey={`${slug}-checks`}
          dialogId="checks"
          exportFilename={`${slug}-checks`}
          emptyMessage="No check images extracted yet."
          variant="checks"
        />
      </div>
    </FiltersProvider>
  )
}
